import { Schema } from "effect";
import { StatisticsValueFromProperties } from "./statistics";
import { encodeBase64 } from "effect/Encoding";
import { addEncodedIdToStruct } from "./utils";
const CursorSchema = Schema.Struct({
    id: Schema.Number,
    archived: Schema.Boolean
});
const CursorUrlParams = Schema.compose(Schema.StringFromBase64Url, Schema.parseJson(CursorSchema));
export const UrlParams = Schema.Struct({
    limit: Schema.NumberFromString.pipe(Schema.optionalWith({
        default: ()=>100
    })),
    cursor: CursorUrlParams.pipe(Schema.optional),
    archived: Schema.BooleanFromString.pipe(Schema.optionalWith({
        default: ()=>false
    }))
});
export const Pagination = Schema.Union(Schema.Struct({
    hasMore: Schema.Literal(true),
    cursor: CursorUrlParams
}), Schema.Struct({
    hasMore: Schema.Literal(false),
    cursor: Schema.Null
}));
const ApplicationPlatform = Schema.Union(Schema.Literal("ios"), Schema.Literal("android"), Schema.Literal("stripe"), Schema.Literal("unknown"));
const ApplicationPlatformAsProperties = Schema.Struct({
    ios: Schema.Literal(true).pipe(Schema.optional),
    android: Schema.Literal(true).pipe(Schema.optional),
    unknown: Schema.Literal(true).pipe(Schema.optional)
});
export const ApplicationPlatformFromProperties = Schema.transform(ApplicationPlatformAsProperties, ApplicationPlatform, {
    encode: (value)=>{
        const result = {};
        // @ts-expect-error
        result[value] = true;
        return result;
    },
    decode: (toEncode)=>{
        const [key, value] = Object.entries(toEncode)[0];
        return key;
    },
    strict: true
});
export class Model extends Schema.Class("superwall-api-Application-Model")({
    object: Schema.Literal("application"),
    id: Schema.NumberFromString,
    organizationId: Schema.NumberFromString,
    platform: ApplicationPlatformFromProperties,
    name: Schema.String.pipe(Schema.NullOr),
    iconUrl: Schema.String,
    createdAt: Schema.DateFromString
}) {
}
export const Create = Model.pipe(Schema.omit("createdAt", "object", "id", "organizationId"));
export class List extends Schema.Class("superwall-api-Application-List")({
    object: Schema.Literal("list"),
    data: Schema.Array(Model),
    pagination: Pagination
}) {
}
const DateishStringsWithoutZ = Schema.transform(Schema.String, Schema.String, {
    decode: (from)=>from.replace("Z", ""),
    encode: (to)=>to,
    strict: true
});
export const StatisticsParams = Schema.Struct({
    environment: Schema.Literal("PRODUCTION", "SANDBOX"),
    // Schema.Array(Schema.Literal("PRODUCTION", "SANDBOX")),
    organizationId: Schema.NumberFromString,
    // applicationId: Schema.Array(Schema.NumberFromString),
    from: DateishStringsWithoutZ,
    to: DateishStringsWithoutZ
});
export class Statistics extends Schema.Class("superwall-api-Application-Statistics")({
    object: Schema.Literal("statistics"),
    params: Schema.Struct({
        applicationId: Schema.Array(Schema.NumberFromString),
        environment: Schema.Array(Schema.Literal("PRODUCTION", "SANDBOX")),
        // Schema.Array(Schema.Literal("PRODUCTION", "SANDBOX")),
        organizationId: Schema.NumberFromString,
        // applicationId: Schema.Array(Schema.NumberFromString),
        from: Schema.String,
        to: Schema.String
    }),
    statistics: Schema.Array(Schema.Struct({
        key: Schema.String,
        chart: Schema.String,
        name: Schema.String,
        value: StatisticsValueFromProperties,
        description: Schema.String
    }).pipe((s)=>addEncodedIdToStruct(s, (value)=>encodeBase64(`${value.key}-${value.chart}-${value.name}`))))
}) {
}
export class RecentTransaction extends Schema.Class("superwall-api-Application-RecentTransaction")({
    id: Schema.String,
    isProcessing: Schema.Boolean,
    object: Schema.Literal("recent_transaction"),
    placement: Schema.String.pipe(Schema.NullOr),
    type: Schema.String,
    store: Schema.String.pipe(Schema.NullOr),
    price: Schema.Number.pipe(Schema.NullOr),
    purchasedAt: Schema.DateFromString,
    user: Schema.Struct({
        object: Schema.Literal("recent_transaction.user"),
        appUserId: Schema.String
    }).pipe(Schema.NullOr),
    integration: Schema.String,
    paywall: Schema.Struct({
        object: Schema.Literal("recent_transaction.paywall"),
        name: Schema.String
    }).pipe(Schema.NullOr)
}) {
}
export class RecentTransactionList extends Schema.Class("superwall-api-Application-RecentTransactionList")({
    object: Schema.Literal("list"),
    data: Schema.Array(RecentTransaction)
}) {
}
